import { giphyUrl } from '@/app/util/env'
import { getCookie } from '@/util/url'
import { GifResult } from '@giphy/js-fetch-api'
import { timeoutFetch } from 'utils/src/api/fetch'

export const derankUser = async (
    channelId: number,
    accountType: string,
    level: string,
    magicTags: any,
    accessToken: string,
    cookie: string
) => {
    const f = await timeoutFetch({
        url: `${giphyUrl}/api/v4/channels/derank`,
        options: {
            cookie,
            method: 'POST',
            headers: {
                Authorization: `Token ${accessToken}`,
                'Content-Type': 'application/json',
                'X-CSRFToken': getCookie('csrftoken', cookie),
            },
            body: JSON.stringify({
                channel_id: channelId,
                account_type: accountType,
                level: level,
                magic_tags: magicTags,
            }),
        },
    })
    return (await f.json()) as GifResult
}
